const limitConstants = {
  // Limit the phone number field to 11 digits - a standard US phone number + 1 for the country code
  MAX_NUMBER_DIGITS: 11,
};

export default limitConstants;
